import type { Database } from '@/types/database'

type Partner = Database['public']['Tables']['partners']['Row']

// Founding partners, served statically so the section never depends on the
// Supabase project being awake. Mirrors the rows previously stored in the
// `partners` table (Sep 2026). Add new founding partners here.
export const staticPartners: Partner[] = [
  {
    id: 'cab35852-81e5-49bf-b30f-49bd7f1b5db6',
    name: 'Uber',
    logo_url: null,
    website_url: 'https://www.uber.com',
    type: 'founding_member',
    lifespans: ['workspan', 'carespan', 'thrivespan'],
    featured: true,
    display_order: 1,
    active: true,
    created_at: '2026-05-17T13:55:48.375792+00:00',
  },
]
